import { createBoard, dropDisc, isBoardFull, winningLineAt } from './board';
import { Disc, GameState, opponent } from './types';

/** Creates a fresh game. `firstPlayer` defaults to disc 1. */
export function createGame(firstPlayer: Disc = 1): GameState {
  return {
    board: createBoard(),
    currentPlayer: firstPlayer,
    status: 'playing',
    winner: null,
    winningLine: null,
    moveCount: 0,
  };
}

/**
 * Applies a move in `col` for the current player and returns a NEW state.
 * If the game is already over or the move is illegal (full/invalid column),
 * the original state is returned unchanged so callers can detect a no-op.
 */
export function applyMove(state: GameState, col: number): GameState {
  if (state.status !== 'playing') return state;

  const result = dropDisc(state.board, col, state.currentPlayer);
  if (!result) return state;

  const { board, row } = result;
  const moveCount = state.moveCount + 1;
  const line = winningLineAt(board, row, col);

  if (line) {
    return {
      board,
      currentPlayer: state.currentPlayer,
      status: 'won',
      winner: state.currentPlayer,
      winningLine: line,
      moveCount,
    };
  }

  if (isBoardFull(board)) {
    return {
      board,
      currentPlayer: state.currentPlayer,
      status: 'draw',
      winner: null,
      winningLine: null,
      moveCount,
    };
  }

  return {
    board,
    currentPlayer: opponent(state.currentPlayer),
    status: 'playing',
    winner: null,
    winningLine: null,
    moveCount,
  };
}
